import { httpClient } from './http-client.service';
import type {
  FIUListResponse,
  TrafficSplitResponse,
  AADistributionResponse,
  ConversionResponse,
  AAConversionOverallResponse,
  AAConversionByFIPResponse,
  LiveStatusResponse,
} from '../types/smart-router';

/**
 * Admin server wraps all responses in: { status, ver, message, data: <payload>, statusCode }
 * We unwrap .data to get the actual Smart Router payload.
 */
class SmartRouterAPIService {

  /** GET /smart-router/fiu-list */
  async getFiuList(): Promise<FIUListResponse> {
    const response = await httpClient.get('smart-router/fiu-list');
    return response.data.data;
  }

  /** GET /smart-router/traffic-split */
  async getTrafficSplit(fiuId: string, startDate: string, endDate: string): Promise<TrafficSplitResponse> {
    const response = await httpClient.get(
      `smart-router/traffic-split?fiu_id=${encodeURIComponent(fiuId)}&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`
    );
    return response.data.data;
  }

  /** GET /smart-router/aa-distribution */
  async getAADistribution(fiuId: string, startDate: string, endDate: string): Promise<AADistributionResponse> {
    const response = await httpClient.get(
      `smart-router/aa-distribution?fiu_id=${encodeURIComponent(fiuId)}&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`
    );
    return response.data.data;
  }

  /** GET /smart-router/conversion */
  async getConversion(fiuId: string, startDate: string, endDate: string): Promise<ConversionResponse> {
    const response = await httpClient.get(
      `smart-router/conversion?fiu_id=${encodeURIComponent(fiuId)}&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`
    );
    return response.data.data;
  }

  /** GET /smart-router/aa-conversion (overall) */
  async getAAConversionOverall(fiuId: string, startDate: string, endDate: string, level: 'consent' | 'user'): Promise<AAConversionOverallResponse> {
    const response = await httpClient.get(
      `smart-router/aa-conversion?fiu_id=${encodeURIComponent(fiuId)}&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}&level=${encodeURIComponent(level)}&group_by=overall`
    );
    return response.data.data;
  }

  /** GET /smart-router/aa-conversion (by FIP) */
  async getAAConversionByFIP(fiuId: string, startDate: string, endDate: string, level: 'consent' | 'user'): Promise<AAConversionByFIPResponse> {
    const response = await httpClient.get(
      `smart-router/aa-conversion?fiu_id=${encodeURIComponent(fiuId)}&start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}&level=${encodeURIComponent(level)}&group_by=fip`
    );
    return response.data.data;
  }

  /** GET /smart-router/live-status */
  async getLiveStatus(fiuId: string): Promise<LiveStatusResponse> {
    const response = await httpClient.get(
      `smart-router/live-status?fiu_id=${encodeURIComponent(fiuId)}`
    );
    return response.data.data;
  }
}

export const smartRouterAPI = new SmartRouterAPIService();
